import { useState, useEffect } from "react";
import { useActiveBanners } from "@/hooks/useSiteBanners";
import { X, ExternalLink } from "lucide-react";

const SiteBanner = () => {
  const { data: banners } = useActiveBanners();
  const [dismissed, setDismissed] = useState<Set<string>>(new Set());

  useEffect(() => {
    try {
      const stored = JSON.parse(localStorage.getItem("dismissed_banners") || "[]");
      setDismissed(new Set(stored));
    } catch {}
  }, []);

  const dismiss = (id: string) => {
    const next = new Set(dismissed);
    next.add(id);
    setDismissed(next);
    localStorage.setItem("dismissed_banners", JSON.stringify([...next]));
  };

  if (!banners) return null;

  const visible = banners.filter((b) => !dismissed.has(b.id));
  if (visible.length === 0) return null;

  return (
    <div className="w-full">
      {visible.map((b) => (
        <div
          key={b.id}
          className="flex items-center justify-center gap-3 px-4 py-2 text-sm"
          style={{ backgroundColor: b.bg_color, color: b.text_color }}
        >
          <span>{b.message}</span>
          {b.link_url && b.link_text && (
            <a
              href={b.link_url}
              target="_blank"
              rel="noopener noreferrer"
              className="underline font-medium inline-flex items-center gap-1"
              style={{ color: b.text_color }}
            >
              {b.link_text}
              <ExternalLink className="w-3 h-3" />
            </a>
          )}
          {b.is_dismissible && (
            <button onClick={() => dismiss(b.id)} className="ml-2 opacity-70 hover:opacity-100">
              <X className="w-4 h-4" />
            </button>
          )}
        </div>
      ))}
    </div>
  );
};

export default SiteBanner;
